<template>
  <footer class="site-footer">
    <div class="site-footer__inner">
      <div class="site-footer__top">
        <div class="site-footer__brand">
          <h4>{{ company.name }}</h4>
          <p>{{ company.motto }}</p>
        </div>
        <div class="site-footer__links">
          <b-link href="#" @click="goHomeIntro"><span>首页</span></b-link>
          <b-link to="/introduce"><span>公司简介</span></b-link>
          <b-link to="/product"><span>产品介绍</span></b-link>
          <b-link to="/knows"><span>相关知识</span></b-link>
          <b-link to="/contact"><span>联系我们</span></b-link>
        </div>
        <div class="site-footer__contact">
          <p v-for="(c, idx) in company.contacts" :key="idx" class="site-footer__contact-item">
            联系人：{{ c.name }} · 电话：<a :href="'tel:' + c.phone">{{ c.phone }}</a>
          </p>
          <p>{{ company.address }}</p>
        </div>
      </div>
      <div class="site-footer__bottom">
        <p>Copyright © {{ company.name }}</p>
        <a :href="company.icpUrl" target="_blank" rel="noopener">{{ company.icp }}</a>
      </div>
    </div>
  </footer>
</template>

<script>
import { COMPANY } from '@/constants/company'

export default {
  name: 'FooterBottom',
  data () {
    return { company: COMPANY }
  },
  methods: {
    goHomeIntro (event) {
      if (event) event.preventDefault()

      const scrollToIntro = () => {
        const intro = document.getElementById('company-intro')
        if (!intro) return
        const nav = document.querySelector('.header')
        const navHeight = nav ? nav.offsetHeight : 0
        const top = intro.getBoundingClientRect().top + window.pageYOffset - navHeight - 12
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' })
      }

      if (this.$route.path !== '/') {
        this.$router.push('/').catch(() => {})
        this.$nextTick(() => window.setTimeout(scrollToIntro, 120))
        return
      }

      scrollToIntro()
    }
  }
}
</script>

<style lang="scss" scoped>
.site-footer {
  background: var(--color-dark);
  color: rgba(255, 255, 255, 0.85);
  margin-top: 0;

  &__inner {
    max-width: var(--max-width);
    margin: 0 auto;
    padding: 3rem 1.5rem 1.5rem;
  }

  &__top {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 2rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    text-align: left;
  }

  &__brand {
    h4 {
      font-size: 1.125rem;
      font-weight: 600;
      color: #fff;
      margin-bottom: 0.75rem;
    }

    p {
      font-size: 0.875rem;
      line-height: 1.6;
      margin: 0;
      color: rgba(255, 255, 255, 0.65);
    }
  }

  &__links {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    a {
      color: rgba(255, 255, 255, 0.75);
      font-size: 0.9375rem;
      transition: color 0.2s;

      &:hover {
        color: #fff;
      }
    }
  }

  &__contact {
    p {
      font-size: 0.875rem;
      line-height: 1.8;
      margin: 0;
    }

    a {
      color: rgba(255, 255, 255, 0.85);
      text-decoration: none;

      &:hover {
        color: #fff;
      }
    }
  }

  &__bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding-top: 1.25rem;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.5);

    a {
      color: rgba(255, 255, 255, 0.5);
      text-decoration: none;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }

    p {
      margin: 0;
    }
  }
}

@media (max-width: 768px) {
  .site-footer__top {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .site-footer__links {
    align-items: center;
  }

  .site-footer__bottom {
    justify-content: center;
    text-align: center;
  }
}
</style>
